var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomemobileabstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 497,
    viewBox: "0 0 375 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 822,
    height: 497,
    transform: "translate(-36)",
    fill: "url(#paint0_radial_3998_38015)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.007 166.244C290.468 161.651 303.163 160.165 315.378 162.003C320.261 162.736 326.624 163.284 328.757 158.827C329.395 157.494 329.458 155.951 330.016 154.581C331.913 149.946 340.077 149.451 341.647 154.966C342.153 156.736 343.764 158.058 345.592 157.821C347.731 157.547 347.873 155.224 348.595 153.528C350.291 149.556 356.032 148.834 359.772 151.005C363.512 153.17 363.507 157.02 367.299 156.025C371.092 155.029 371.06 147.802 374.605 142.008C376.875 138.294 380.473 134.428 385.33 136.656C386.441 137.167 387.405 137.946 388.232 138.842C392.994 144.02 397.208 151.1 395.88 158.005C394.205 166.718 382.617 172.512 368.853 172.512C348.81 175.309 287.029 168.609 245 171.48",
    stroke: "#D1D2DC",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7242 112.197C114.418 114.959 126.972 110.438 145.055 110.395C150.652 110.38 156.254 110.371 161.851 110.356C170.8 110.337 179.763 110.312 188.688 109.586C189.66 107.299 186.58 105.283 184.092 105.351C181.605 105.419 178.928 106.364 176.746 105.172C175.507 104.493 174.706 103.253 173.681 102.279C170.712 99.4544 165.621 99.2364 162.419 101.795C161.54 102.502 160.636 103.437 159.509 103.34C158.761 103.272 158.144 102.749 157.614 102.226C153.985 98.6307 151.05 93.3495 145.959 92.865C140.124 92.3127 136.184 100.947 134.833 101.155C133.483 101.363 130.898 97.1917 126.691 95.7624C123.202 94.5802 119.073 95.8835 116.634 98.6356C116.279 99.0329 115.929 99.4835 115.419 99.6288C114.38 99.9292 113.495 98.8585 112.932 97.933C110.473 93.8922 107.622 89.7496 103.302 87.8115C98.9834 85.8734 93.5275 87.5063 91.244 91.6489C89.4027 94.9872 90.1363 101.741 87.0464 102.182C83.9565 102.623 79.8366 97.9282 75.7119 99.5416C71.592 101.155 69.3814 108.055 66 108.055",
    stroke: "#D1D2DC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_3998_38015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.339 392.289C267.418 392.289 266.606 392.729 266.121 393.398C265.504 391.82 263.901 390.694 262.021 390.694C259.606 390.694 257.648 392.55 257.648 394.84H271.031C271.031 393.431 269.826 392.289 268.341 392.289H268.339Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.337 366.855C277.948 365.311 278.71 363.277 279.857 362.933C281.323 362.493 283.067 364.222 284.229 362.901C284.587 362.496 284.796 361.863 285.189 361.527C286.086 360.755 287.17 361.938 288.204 362.222C290.1 362.744 291.705 360.167 293.606 359.679C295.088 359.3 296.702 360.375 297.421 362.221C297.804 363.204 298.074 364.516 298.857 364.766C299.526 364.978 300.137 364.246 300.781 363.916C302.199 363.187 303.955 364.665 303.97 366.772L278.338 366.858L278.337 366.855Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.884 329.549C157.045 331.086 152.603 330.628 148.531 329.989",
    stroke: "#D1D2DC",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.822 329.549C157.365 330.102 155.834 330.218 154.323 330.494C152.872 330.761 151.439 331.145 150.039 331.644C147.316 332.614 144.728 334.008 142.352 335.767",
    stroke: "#D1D2DC",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0607 377.393V379.733H86.5546V383.253H83.0499V386.775H79.5452V390.295H76.0391V392.33",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5469 390.293H85.2921",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0742 386.77H89.022",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5547 383.254H92.9174",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0586 379.733H95.836",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5633 376.213H90.0586V379.733",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4141 387.674L99.5327 378.542",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.941 382.77H283.687",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.469 379.247H284.205",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.949 375.731H291.675",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.457 372.21H294.234",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.456 369.87V372.21H284.95V375.732H281.445V379.252H277.94V382.773H274.434V385.733H270.93V388.632",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.035 368.69H288.457V372.211",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.668 379.294L300.974 367.97",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.434 385.733H279.691",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.716 401.822V396.27C201.716 394.475 200.99 393.601 200.391 391.986C200.018 390.982 199.238 390.345 198.385 390.345H187.867C187.013 390.345 186.234 390.982 185.861 391.986C185.262 393.601 184.535 394.475 184.535 396.27V400.875",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.528 366.695H119.988",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.348 390.343H137.875C141.795 380.404 151.45 373.375 162.739 373.375C174.029 373.375 183.684 380.404 187.603 390.343H198.271C202.191 380.404 211.846 373.375 223.135 373.375C234.424 373.375 244.079 380.404 247.999 390.343H256.527V393.967",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.718 387.519H249.846C244.971 377.149 234.689 370.55 223.138 370.55C211.588 370.55 201.304 377.149 196.43 387.519H189.452C184.577 377.149 174.295 370.55 162.744 370.55C151.193 370.55 140.91 377.149 136.036 387.519H132.164",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.652 360.286H263.154V361.805L264.312 361.798V366.737",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.918 360.286H246.661",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.098 360.286H230.896",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.277 360.286H215.109",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.531 360.286H199.347",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73 360.286H183.561",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 360.286H167.73",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.195 360.286H151.902",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.404 400.72V396.268C141.404 394.474 140.678 393.6 140.078 391.985C139.705 390.98 138.926 390.343 138.072 390.343H129.348V393.027",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.529 390.343H247.328C246.474 390.343 245.695 390.98 245.322 391.985C244.722 393.6 243.996 394.474 243.996 396.268V401.82",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.684 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.912 355.907L137.684 354.673L136.455 355.907L137.684 357.141L138.912 355.907Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.293 359.303V362.094H136.931V366.695H138.434V362.094H139.071V359.303H136.293Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.469 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.697 355.906L153.469 354.672L152.24 355.906L153.469 357.141L154.697 355.906Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.082 359.303V362.094H152.719V366.695H154.222V362.094H154.859V359.303H152.082Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.258 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.487 355.906L169.258 354.672L168.029 355.906L169.258 357.14L170.487 355.906Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.867 359.303V362.094H168.504V366.695H170.007V362.094H170.646V359.303H167.867Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.047 359.314V357.052",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.276 355.906L185.047 354.672L183.818 355.906L185.047 357.14L186.276 355.906Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.656 359.303V362.094H184.293V366.695H185.798V362.094H186.435V359.303H183.656Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.836 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.065 355.905L200.836 354.671L199.607 355.905L200.836 357.139L202.065 355.905Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.441 359.303V362.094H200.078V366.695H201.583V362.094H202.22V359.303H199.441Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.621 359.314V357.052",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.85 355.907L216.621 354.673L215.392 355.907L216.621 357.142L217.85 355.907Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.23 359.303V362.094H215.869V366.695H217.372V362.094H218.009V359.303H215.23Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.41 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.639 355.907L232.41 354.673L231.181 355.907L232.41 357.141L233.639 355.907Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.02 359.303V362.094H231.657V366.695H233.16V362.094H233.796V359.303H231.02Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.195 359.313V357.051",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.424 355.906L248.195 354.672L246.967 355.906L248.195 357.141L249.424 355.906Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.809 359.303V362.094H247.446V366.695H248.949V362.094H249.587V359.303H246.809Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45 363.141V361.806H140.89V363.141H140.004V364.062C140.004 364.739 140.55 365.287 141.223 365.287H150.117C150.79 365.287 151.337 364.739 151.337 364.062V363.141H150.451H150.45Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.098 363.141V361.806H156.538V363.141H155.652V364.062C155.652 364.739 156.199 365.287 156.872 365.287H165.766C166.439 365.287 166.985 364.739 166.985 364.062V363.141H166.099H166.098Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.032 363.141V361.806H172.472V363.141H171.586V364.062C171.586 364.739 172.132 365.287 172.805 365.287H181.699C182.372 365.287 182.919 364.739 182.919 364.062V363.141H182.033H182.032Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68 363.141V361.806H188.12V363.141H187.234V364.062C187.234 364.739 187.781 365.287 188.454 365.287H197.348C198.021 365.287 198.567 364.739 198.567 364.062V363.141H197.681H197.68Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.328 363.141V361.806H203.768V363.141H202.883V364.062C202.883 364.739 203.429 365.287 204.102 365.287H212.996C213.669 365.287 214.215 364.739 214.215 364.062V363.141H213.33H213.328Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.258 363.141V361.806H219.698V363.141H218.812V364.062C218.812 364.739 219.359 365.287 220.032 365.287H228.926C229.599 365.287 230.145 364.739 230.145 364.062V363.141H229.26H229.258Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.192 363.141V361.806H235.632V363.141H234.746V364.062C234.746 364.739 235.292 365.287 235.966 365.287H244.859C245.533 365.287 246.079 364.739 246.079 364.062V363.141H245.193H245.192Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.038 363.134V361.799H256.53L251.022 361.806V363.141H250.137V364.062C250.137 364.739 250.683 365.287 251.356 365.287H256.53L261.704 365.28C262.377 365.28 262.923 364.732 262.923 364.055V363.134H262.038Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.293 360.321H122.791V361.84L121.633 361.833V366.772",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.909 363.168V361.833H129.417L134.925 361.84V363.175H135.81V364.096C135.81 364.773 135.264 365.321 134.591 365.321H129.417L124.243 365.314C123.57 365.314 123.023 364.766 123.023 364.089V363.168H123.909Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.977 391.874V394.995",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.051 391.874V394.995",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.891 390.377V386.551C357.891 385.899 358.417 385.37 359.067 385.37H371.787C372.436 385.37 372.963 385.899 372.963 386.551V390.464",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.11 390.241H355.711V391.817H375.11V390.241Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.394 368.554C369.3 366.606 368.115 364.767 367.361 363.632C366.988 363.071 366.167 363.071 365.794 363.632C364.07 366.223 360.102 372.498 360.102 375.311C360.102 378.903 363.001 381.816 366.577 381.816C368.791 381.816 370.747 380.699 371.915 378.997",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.574 375.176V384.268",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41 346.468C100.41 350.816 103.919 354.341 108.248 354.341C112.577 354.341 116.086 350.816 116.086 346.468C116.086 343.064 111.282 335.471 109.196 332.334C108.745 331.655 107.752 331.655 107.301 332.334C105.215 335.471 100.412 343.064 100.412 346.468H100.41Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25 346.307V363.986",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.179 350.19L106.246 348.249",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.004 342.468C98.888 340.481 97.6797 338.604 96.91 337.446C96.5301 336.874 95.692 336.874 95.312 337.446C93.5534 340.091 89.5039 346.492 89.5039 349.361C89.5039 353.026 92.4624 355.998 96.111 355.998C98.3697 355.998 100.364 354.858 101.556 353.121",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1133 349.225V366.64",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.241 349.217L70.5234 349.263",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.847 299.382H65.5898V297.022H105.978V299.382H104.527",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.42 352.233V299.383H107.043",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.043 297.022H118.872V299.382H117.42",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1138 304.184H73.2852V307.025H76.1138V304.184Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3208 304.184H80.4922V307.025H83.3208V304.184Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5318 304.184H87.7031V307.025H90.5318V304.184Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7388 304.184H94.9102V307.025H97.7388V304.184Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9185 311.32H73.0898V314.161H75.9185V311.32Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3364 311.32H87.5078V314.161H90.3364V311.32Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5435 311.32H94.7148V314.161H97.5435V311.32Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5278 325.593H72.6992V328.434H75.5278V325.593Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9458 325.593H87.1172V328.434H89.9458V325.593Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1568 325.593H94.3281V328.434H97.1568V325.593Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3364 332.729H72.5078V335.571H75.3364V332.729Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5435 332.729H79.7148V335.571H82.5435V332.729Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7505 332.729H86.9219V335.571H89.7505V332.729Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 307.957H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 311.609H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 315.263H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 318.915H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 322.568H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 326.221H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 329.874H112.957",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.528 335.531V307.896H103.846V304.244H104.528V299.383H66.8477V320.409",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4689 340.034C83.5902 340.688 83.4883 341.987 83.4883 341.987C83.4883 341.987 84.8111 342.228 85.6911 341.574C86.5697 340.921 86.6717 339.621 86.6717 339.621C86.6717 339.621 85.3489 339.38 84.4689 340.034Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.428 341.443C74.1571 342.251 75.5037 342.268 75.5037 342.268C75.5037 342.268 75.6685 340.974 74.9394 340.166C74.2102 339.358 72.8636 339.341 72.8636 339.341C72.8636 339.341 72.6988 340.634 73.428 341.443Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4123 343.25C81.1082 343.25 81.6723 342.704 81.6723 342.03C81.6723 341.357 81.1082 340.811 80.4123 340.811C79.7165 340.811 79.1523 341.357 79.1523 342.03C79.1523 342.704 79.7165 343.25 80.4123 343.25Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7297 341.093C78.2319 341.093 78.639 340.699 78.639 340.212C78.639 339.725 78.2319 339.331 77.7297 339.331C77.2274 339.331 76.8203 339.725 76.8203 340.212C76.8203 340.699 77.2274 341.093 77.7297 341.093Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 345.155H86.6719V343.401H72.85V345.155Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1836 320.068H82.5441",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5312 320.068H98.8917",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6172 318.915V321.419",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.207 318.915V321.419",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.992 325.501L350.518 326.119L352.043 325.501L353.568 326.119L355.094 325.501L356.62 326.119L358.146 325.501L359.673 326.119L361.199 325.501",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.672 326.119L346.199 325.501L347.725 326.119L349.252 325.501",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 324.712L352.041 324.093L353.566 324.712L355.092 324.093L356.618 324.712L358.144 324.093L359.671 324.712",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.344 387.86H329.888",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.801 387.794V386.725",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.247 333.709H357.488",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.875 334.444V333.709",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.847 394.484V392.887H335.438V330.054",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.115 334.368H331.004V335.413H334.115V334.368Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.208 332.787H329.098V333.832H332.208V332.787Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.426 328.241H307.102V329.937H337.426V328.241Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.328 328.241H364.254V329.937H337.043",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84 328.241L311.048 320.563H359.955L362.163 328.241",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.293 320.563L335.501 328.241",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.297 325.811L313.718 323.592L316.115 325.787H317.865L315.468 323.592H313.718",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.871 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.574 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.113 325.811V328.241",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.158 326.111H313.121V327.026H314.158V326.111Z",
    fill: "#72BE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.914 325.811L321.335 323.592L323.73 325.787H325.482L323.085 323.592H321.335",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.488 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.191 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73 325.811V328.241",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.775 326.111H320.738V327.026H321.775V326.111Z",
    fill: "#72BE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.531 325.811L328.953 323.592L331.349 325.787H333.099L330.704 323.592H328.953",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.105 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.812 325.284V328.24",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.348 325.811V328.241",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.392 326.111H328.355V327.026H329.392V326.111Z",
    fill: "#72BE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.816 320.563V317.676H321.452V320.563",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.453 317.676H322.93V320.563",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.426 320.563V319.119H345.817V320.563",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.816 319.119H349.035V320.563",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.083 372.822H311.805V381.532H316.083V372.822Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.923 372.822H319.645V381.532H323.923V372.822Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.767 372.822H327.488V381.532H331.767V372.822Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.083 361.302H311.805V370.013H316.083V361.302Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.923 361.302H319.645V370.013H323.923V361.302Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.767 361.302H327.488V370.013H331.767V361.302Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.083 349.782H311.805V358.492H316.083V349.782Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.923 349.782H319.645V358.492H323.923V349.782Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.767 349.782H327.488V358.492H331.767V349.782Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.083 338.263H311.805V346.973H316.083V338.263Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.923 338.263H319.645V346.973H323.923V338.263Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.767 338.263H327.488V346.973H331.767V338.263Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.945 372.822V381.532",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.805 375.496H316.083",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.805 378.765H316.083",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.051 392.597V384.268H351.252V392.597",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.863 392.597H354.442",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.781 363.666H358.869",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.781 355.438H358.869",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.781 347.21H358.869",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.781 338.983H358.869",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.523 345.682V366.737",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.523 336.332V342.965",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.863 355.779V366.737",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.863 336.332V360.416",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.149 367.093V359.115H361.434V355.956H362.149V330.054",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84 392.12V358.999H309.555V355.839H308.84V329.937",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.037 392.657H306.398V394.912",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.016 376.148L345.288 376.916",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.055 376.432L346.601 376.148",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.277 377.19H349.878",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68 376.531L351.406 376.916",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.809 377.574L354.355 378.013",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 376.916L355.226 376.432",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.055 377.574L346.328 379.494",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64 377.574L350.367 379.714",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.675 379.426C346.006 379.876 345.753 380.63 345.753 380.63C345.753 380.63 344.963 380.652 344.632 380.2C344.3 379.75 344.553 378.996 344.553 378.996C344.553 378.996 345.344 378.974 345.675 379.426Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.676 378.556C348.524 379.095 347.775 379.353 347.775 379.353C347.775 379.353 347.275 378.737 347.427 378.198C347.58 377.659 348.328 377.401 348.328 377.401C348.328 377.401 348.828 378.017 348.676 378.556Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.816 380.261C355.459 380.588 354.791 380.436 354.791 380.436C354.791 380.436 354.702 379.754 355.059 379.427C355.417 379.1 356.085 379.252 356.085 379.252C356.085 379.252 356.174 379.934 355.816 380.261Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.637 379.385C353.428 380.119 352.41 380.47 352.41 380.47C352.41 380.47 351.73 379.632 351.938 378.9C352.146 378.166 353.164 377.815 353.164 377.815C353.164 377.815 353.845 378.653 353.637 379.385Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.162 379.958C357.162 376.016 353.981 372.822 350.057 372.822C346.134 372.822 342.953 376.016 342.953 379.958",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.953 381.065H357.162",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6367 392.984L13.6367 373.191",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 364.303V326.289H60.7374V364.303",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0375 373.191L13.6367 373.191",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 368.399L12.9794 367.472H56.6464",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 375.388C16.0022 375.211 16.744 374.654 17.1728 373.897C17.6966 374.821 18.6842 375.447 19.8184 375.447C20.9527 375.447 21.9416 374.821 22.4641 373.897C22.9879 374.821 23.9755 375.447 25.1097 375.447C26.2439 375.447 27.2329 374.821 27.7553 373.897C28.2778 374.821 29.2667 375.447 30.401 375.447C31.5352 375.447 32.5242 374.821 33.0466 373.897C33.569 374.821 34.558 375.447 35.6922 375.447C36.8265 375.447 37.8155 374.821 38.3379 373.897C38.8603 374.821 39.8493 375.447 40.9835 375.447C42.1178 375.447 43.1067 374.821 43.6292 373.897C44.1516 374.821 45.1406 375.447 46.2748 375.447",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4486 383.622C51.859 380.664 48.7454 378.655 45.1653 378.655H44.5562C39.3599 378.655 35.1484 382.885 35.1484 388.104",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9555 392.135V382.904H17.7422V392.135",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9805 392.135V382.904",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7451 381.403H24.957V379.85H17.7451V381.403Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2773 366.077V364.302H62.5515",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.793 326.289H68.2379V364.303",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8203 364.302H72.2767V367.936",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5674 326.289H15.3047V324.352H61.7416V326.289H60.7345",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7422 324.352H69.2461V326.289H68.2389",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 383.864H32.2852V380.721H29.1562V383.864Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4856 348.425H52.3984V360.883H56.4856V348.425Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3984 352.233H56.487",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3984 354.199H56.487",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 324.352L39.4968 319.74L59.5822 324.352",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0852 324.352L46.0012 319.74H39.4961",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 327.765H68.2413",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0762 332.321H21.6484V342.923H34.0762V332.321Z",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3661 338.891H38.3516V342.923H42.3661V338.891Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5067 338.891H45.4922V342.923H49.5067V338.891Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6474 338.891H52.6328V342.923H56.6474V338.891Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6484 347.926H48.7725",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3516 334.97H56.6503",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3315 389.298H33.9805V388.103H36.8831",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3164 367.468V366.077",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.082 357.778V355.346C43.082 354.008 44.1618 352.924 45.493 352.924C46.8242 352.924 47.904 354.008 47.904 355.346V357.778",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0234 361.063H49.9605",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9414 358.394V355.346C32.9414 354.008 34.0212 352.924 35.3524 352.924C36.6836 352.924 37.7633 354.008 37.7633 355.346V358.487",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8867 361.063H39.8238",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8047 357.959V355.346C22.8047 354.008 23.8845 352.924 25.2157 352.924C26.5469 352.924 27.6266 354.008 27.6266 355.346V357.837",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7461 361.063H29.6832",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2399 358.164C22.9229 358.69 23.0026 359.74 23.0026 359.74C23.0026 359.74 21.9745 359.935 21.29 359.407C20.607 358.881 20.5273 357.832 20.5273 357.832C20.5273 357.832 21.5554 357.636 22.2399 358.164Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5936 359.468C28.1158 360.018 27.233 360.029 27.233 360.029C27.233 360.029 27.1255 359.149 27.6032 358.599C28.0809 358.049 28.9637 358.038 28.9637 358.038C28.9637 358.038 29.0713 358.918 28.5936 359.468Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2641 359.758C25.2641 360.157 24.9428 360.479 24.5461 360.479C24.1494 360.479 23.8281 360.157 23.8281 359.758C23.8281 359.36 24.1494 359.037 24.5461 359.037C24.9428 359.037 25.2641 359.36 25.2641 359.758Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5951 358.683C26.5951 358.971 26.3632 359.204 26.0768 359.204C25.7905 359.204 25.5586 358.971 25.5586 358.683C25.5586 358.396 25.7905 358.163 26.0768 358.163C26.3632 358.163 26.5951 358.396 26.5951 358.683Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1056 358.603C43.6895 359.052 43.7566 359.947 43.7566 359.947C43.7566 359.947 42.878 360.113 42.2955 359.664C41.7116 359.215 41.6445 358.32 41.6445 358.32C41.6445 358.32 42.5232 358.154 43.1056 358.603Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4113 359.541C48.8009 360.242 47.6736 360.258 47.6736 360.258C47.6736 360.258 47.5353 359.134 48.1457 358.431C48.7562 357.729 49.8834 357.714 49.8834 357.714C49.8834 357.714 50.0217 358.838 49.4113 359.541Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7708 359.575C45.3964 360.006 44.7036 360.016 44.7036 360.016C44.7036 360.016 44.6184 359.326 44.9942 358.895C45.3685 358.464 46.0613 358.454 46.0613 358.454C46.0613 358.454 46.1466 359.145 45.7708 359.575Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1962 359.222C35.1962 359.657 34.8456 360.009 34.4125 360.009C33.9795 360.009 33.6289 359.657 33.6289 359.222C33.6289 358.787 33.9795 358.435 34.4125 358.435C34.8456 358.435 35.1962 358.787 35.1962 359.222Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9713 357.897C36.9713 358.212 36.7185 358.466 36.4056 358.466C36.0927 358.466 35.8398 358.212 35.8398 357.897C35.8398 357.583 36.0927 357.329 36.4056 357.329C36.7185 357.329 36.9713 357.583 36.9713 357.897Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5283 359.1C33.4542 359.087 33.3802 359.082 33.302 359.082C32.5393 359.082 31.9219 359.702 31.9219 360.468",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.058 360.468C39.058 359.702 38.4406 359.082 37.6779 359.082C37.2547 359.082 36.8761 359.274 36.6233 359.576C36.3705 359.274 35.9919 359.082 35.5673 359.082C35.4849 359.082 35.4024 359.089 35.3242 359.103",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1562 378.274V384.437",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.528 398.161C182.739 397.583 182.07 396.913 180.52 396.913C177.795 396.913 177.795 398.985 175.068 398.985C172.342 398.985 172.343 396.913 169.616 396.913C166.89 396.913 166.89 398.985 164.165 398.985C161.439 398.985 161.438 396.913 158.711 396.913C155.985 396.913 155.985 398.985 153.258 398.985C150.531 398.985 150.531 396.913 147.805 396.913C145.078 396.913 145.078 398.985 142.352 398.985",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.235 397.773C242.464 398.342 241.791 398.985 240.271 398.985C237.542 398.985 237.542 396.913 234.812 396.913C232.082 396.913 232.083 398.985 229.353 398.985C226.623 398.985 226.624 396.913 223.894 396.913C221.164 396.913 221.166 398.985 218.435 398.985C215.705 398.985 215.705 396.913 212.976 396.913C210.248 396.913 210.248 398.985 207.518 398.985C204.787 398.985 204.787 396.913 202.059 396.913",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.646 403.131C219.945 403.131 219.945 402.094 217.242 402.094C214.539 402.094 214.54 403.131 211.838 403.131C209.135 403.131 209.136 402.094 206.433 402.094C203.73 402.094 203.732 403.131 201.029 403.131C198.326 403.131 198.327 402.094 195.624 402.094C192.921 402.094 192.923 403.131 190.22 403.131C187.517 403.131 187.517 402.094 184.815 402.094C182.114 402.094 182.114 403.131 179.411 403.131C176.708 403.131 176.708 402.094 174.007 402.094C171.305 402.094 171.305 403.131 168.602 403.131C165.899 403.131 165.899 402.094 163.198 402.094C160.496 402.094 160.496 403.131 157.793 403.131C155.091 403.131 155.091 402.094 152.389 402.094C149.688 402.094 149.688 403.131 146.985 403.131C144.282 403.131 144.283 402.094 141.58 402.094C138.877 402.094 138.877 403.131 136.176 403.131",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.412 402.094C246.753 402.094 246.753 403.131 244.094 403.131C241.434 403.131 241.435 402.094 238.775 402.094C236.116 402.094 236.116 403.131 233.457 403.131C230.799 403.131 230.797 402.094 228.139 402.094C225.481 402.094 225.479 403.131 222.82 403.131C220.16 403.131 220.16 402.094 217.5 402.094",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51 350.471C240.306 351.008 239.784 351.307 239.344 351.139C238.904 350.97 238.714 350.398 238.918 349.86C239.122 349.323 239.644 349.024 240.084 349.193C240.524 349.361 240.714 349.933 240.51 350.471Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.926 352.159C237.932 355.512 237.789 359.15 237.789 359.15",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.637 359.803V358.001H242.69V359.773",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.156 353.396C240.156 353.396 240.866 354.68 240.82 355.442C240.774 356.203 240.489 357.296 240.489 357.296",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.281 357.082L239.707 352.302L240.552 351.802C241.476 353.373 241.981 354.426 241.981 355.434C241.981 356.441 240.844 358.073 240.844 358.073",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.762 349.985C178.847 350.491 178.617 350.96 178.238 351.089",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.689 349.918C177.689 349.918 176.845 350.766 177.207 352.521C177.569 354.276 176.785 354.518 176.183 354.276C175.581 354.034 175.339 352.764 176.003 351.312C176.665 349.86 176.502 349.363 176.967 348.952C177.629 348.367 178.614 348.649 178.774 349.638L177.69 349.92L177.689 349.918Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.539 352.733C177.539 352.733 178.701 355.045 179.658 354.438C180.231 354.074 177.961 350.948 177.961 350.948",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.058 359.3L179.055 355.002",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.663 354.699L176.027 359.35",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.238 349.918L178.021 350.523",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57 351.129L178.263 352.733",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.367 355.729L178.05 356.495",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.357 349.7H130.339L131.645 345.939H127.051L128.357 349.7Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.348 349.672V360.192",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.033 353.35H128.66",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.964 343.752L131.156 344.563",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.73 343.752L127.538 344.563",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.227 343.468V342.21",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.323 342.256H162.305L163.611 338.495H159.016L160.323 342.256Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.312 342.23V360.292",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.002 345.907H160.629",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.934 336.307L163.125 337.118",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.699 336.307L159.507 337.118",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.191 336.025V334.767",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.333 342.256H225.317L226.623 338.495H222.027L223.333 342.256Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.324 342.23V360.292",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.014 345.907H223.641",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.942 336.307L226.133 337.118",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.707 336.307L222.516 337.118",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.203 336.025V334.767",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.537 349.844H257.519L258.825 346.084H254.23L255.537 349.844Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.527 349.817V360.286",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.213 353.495H255.84",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.143 343.895L258.336 344.706",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91 343.895L254.718 344.706",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.402 343.613V342.355",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.269 363.985L95.4414 373.007H124.616L110.269 363.985Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.267 363.985L105.656 373.007",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.959 373.007L110.348 363.985V362.849",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5039 373.007C95.5039 374.782 96.9371 376.22 98.7027 376.22C99.9319 376.22 100.999 375.522 101.534 374.5C102.069 375.521 103.136 376.22 104.366 376.22C105.595 376.22 106.662 375.522 107.197 374.5C107.732 375.521 108.799 376.22 110.028 376.22C111.258 376.22 112.325 375.522 112.86 374.5C113.395 375.521 114.462 376.22 115.691 376.22C116.92 376.22 117.988 375.522 118.523 374.5C119.058 375.521 120.125 376.22 121.354 376.22C123.121 376.22 124.553 374.782 124.553 373.007",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.115 381.16C107.115 381.16 106.421 381.858 105.727 381.814",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.33 384.036C106.33 384.036 106.195 385.853 107.23 386.545C107.649 386.824 108.793 386.893 109.249 386.861",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.512 382.99C105.022 384.037 104.524 385.639 104.037 386.847C103.303 388.674 104.834 389.116 105.707 389.392C106.462 389.631 107.828 390.144 107.828 390.144C107.218 391.964 106.71 394.494 106.71 394.494",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.591 394.492C107.591 394.492 109.607 390.143 109.196 389.448C108.908 388.963 108.193 388.538 107.551 388.177C106.784 387.746 106.324 387.628 106.324 387.035",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.485 384.456C103.938 384.052 103.765 383.27 104.686 382.375C105.606 381.479 105.553 380.898 106.331 380.638H106.548C107.003 380.638 107.372 381.166 107.372 381.815C107.372 382.465 107.003 382.993 106.548 382.993C106.284 382.993 106.049 382.816 105.898 382.541",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34 383.551C103.351 385.764 101.96 387.637 102.928 389.076C103.579 390.045 105.493 390.143 105.493 390.143",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.298 390.045C104.348 394.259 102.941 394.818 102.941 394.818",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.499 384.036C119.499 384.036 119.055 385.994 118.369 386.468C117.956 386.754 116.379 386.892 115.922 386.861",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.601 383.253C120.601 383.253 121.259 385.451 121.523 386.847C121.745 388.027 121.47 388.728 120.812 389.07C120.08 389.451 117.774 390.333 117.774 390.333L116.059 394.467",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.074 394.467C115.074 394.467 116.065 390.116 116.537 389.461C117.016 388.796 119.664 387.44 119.664 387.44L119.734 386.127",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.505 382.897C119.406 382.959 119.296 382.993 119.18 382.993C118.724 382.993 118.355 382.465 118.355 381.816C118.355 381.166 118.58 380.714 119.107 380.564L119.279 380.536C120.49 380.438 120.779 381.127 120.913 381.609C121.111 382.321 120.775 382.872 120.047 382.711C119.586 382.573 119.917 382.022 119.712 381.528L118.355 381.489",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.985 383.551C121.973 385.764 123.365 387.637 122.397 389.076C121.746 390.045 119.832 390.143 119.832 390.143",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.025 390.045C121.013 391.025 121.085 391.808 121.202 392.431",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.527 387.674H116.969",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.973 382.013V382.546",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.746 381.16L112.944 381.489",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.159 382.28L112.945 382.546",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.582 382.87L112.78 384.271",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.973 386.868L112.246 384.371H113.314L113.587 386.812",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.941 388.86H113.527",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.746 388.86V394.467",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.348 376.221V385.841",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5105 363.858L49.7891 372.816H78.757L64.5105 363.858Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5111 363.858L59.9336 372.816",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1648 372.816L64.5859 363.858V362.75",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8516 372.817C49.8516 374.579 51.2736 376.007 53.028 376.007C54.2489 376.007 55.3077 375.314 55.8399 374.3C56.3721 375.314 57.4309 376.007 58.6503 376.007C59.8698 376.007 60.93 375.314 61.4622 374.3C61.9944 375.314 63.0532 376.007 64.2727 376.007C65.4921 376.007 66.5523 375.314 67.0845 374.3C67.6167 375.314 68.6755 376.007 69.895 376.007C71.1144 376.007 72.1747 375.314 72.7069 374.3C73.2391 375.314 74.2979 376.007 75.5173 376.007C77.2718 376.007 78.6938 374.579 78.6938 372.817",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3828 394.171V389.187H74.4141V383.992",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7436 394.171V389.187H55.7109V383.992",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7656 390.328L73.9837 394.121",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3757 390.328L56.1562 394.121",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3086 381.967L68.7682 383.358",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9688 385.935L68.2411 383.456H69.3L69.5723 385.879",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9453 386.736H71.2336",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7852 387.913H65.358",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5898 387.913V393.481",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5859 376.007V385.559",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6367 383.115L69.7947 380.664",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1668 381.716L68.1094 380.783",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.293 366.858H72.3516",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.088 366.858H114.559",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.533 372.04C134.997 372.74 135.01 373.69 135.642 374.388C136.273 375.085 137.33 375.317 138.237 375.026L135.533 372.04Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.885 377.222C252.349 378.156 252.362 379.421 252.993 380.352C253.625 381.282 254.681 381.591 255.588 381.204L252.885 377.222Z",
    fill: "#CECFD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.235 381.394C102.611 380.444 101.549 380.058 100.589 380.536C99.6284 381.013 99.0622 382.207 99.1214 383.44L103.235 381.394Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.969 373.785C268.345 373.151 267.284 372.894 266.323 373.213C265.363 373.531 264.797 374.327 264.856 375.149L268.969 373.785Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.914 353.476C270.971 353.469 271.027 353.455 271.083 353.434C271.434 353.299 271.625 352.909 271.585 352.484",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.664 361.986L271.948 366.676",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.567 363.084L266.234 366.676",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.327 355.07C268.76 356.125 268.457 356.933 268.457 357.712C268.457 358.491 269.223 359.511 269.598 359.976C269.703 360.107 269.9 360.113 270.013 359.989C270.094 359.901 270.11 359.772 270.051 359.666C269.841 359.296 269.373 358.409 269.337 357.823C269.29 357.065 269.92 356.01 269.92 356.01",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 358.057H267.645V360.979H272.3V358.057H270.206",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.052 357.941C271.052 357.941 270.954 356.239 270.418 355.088",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.37 366.592L270.672 361.974",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.191 365.774L268.926 362.15",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.488 362.52C267.811 362.115 268.428 361.98 268.889 362.216C269.117 362.332 269.313 362.529 269.565 362.568C270.137 362.655 270.532 361.913 271.108 361.865C271.416 361.84 271.7 362.019 271.979 362.154C272.259 362.289 272.618 362.372 272.861 362.178",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.695 354.667C268.288 354.34 268.122 353.79 268.666 353.205C269.209 352.62 269.296 351.743 269.529 351.432C269.762 351.12 270.181 350.789 270.731 350.866C271.498 350.973 272.04 351.889 271.546 352.181C271.104 352.442 270.255 352.132 270.178 352.707C270.102 353.282 270.963 354.345 270.092 354.841C269.54 355.156 268.889 354.822 268.695 354.666V354.667Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.906 354.433C270.965 355.164 271.577 355.724 271.663 356.187C271.75 356.654 271.518 357.21 271.489 357.706",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.395 392.233V394.977",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.094 386.511H300.283C300.854 386.511 301.318 386.977 301.318 387.551V390.796",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.219 390.797H303.205V392.181H290.639",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.798 394.846C100.8 394.826 100.805 394.808 100.805 394.788C100.953 394.805 101.111 394.758 101.222 394.612C101.856 393.777 102.218 392.482 101.263 391.716C101.038 391.535 100.798 391.47 100.517 391.422C100.236 391.375 99.9763 391.394 99.8324 391.108C99.6256 390.696 99.729 390.111 99.7681 389.673C99.9581 387.532 98.8713 384.737 96.4366 384.47C95.3569 384.352 94.4824 384.999 94.0662 385.969C93.6373 386.964 93.703 388.083 93.2909 389.079C93.0702 389.612 92.6959 390.094 92.0827 390.143C91.4275 390.195 90.8003 389.833 90.1648 389.733C89.1549 389.576 88.1757 389.93 87.9256 390.996C87.8446 391.341 87.7985 391.581 87.4395 391.704C87.135 391.81 86.7914 391.798 86.4729 391.805C85.8932 391.82 85.3512 391.894 84.8134 392.121C83.7686 392.563 82.9249 393.47 82.9417 394.659C82.9417 394.722 82.9612 394.786 82.9891 394.845H100.795L100.798 394.846Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0156 394.678L96.9347 391.574L97.5605 389.183",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8503 391.406L95.8906 388.848",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.936 378.258C126.807 379.362 127.166 380.508 127.881 381.06C128.596 381.611 129.447 381.395 129.998 380.615L126.936 378.258Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.828 383.44C262.655 384.176 263.134 384.94 264.088 385.308C265.041 385.675 266.175 385.531 266.911 385.011L262.828 383.44Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1395 365.718C83.1206 364.536 82.962 362.779 81.7853 361.793C80.6085 360.808 78.8592 360.967 77.8781 362.149C76.8969 363.331 77.0555 365.088 78.2323 366.074C79.409 367.059 81.1584 366.9 82.1395 365.718Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4987 366.507C90.9142 365.918 91.5864 364.288 91.0001 362.866C90.4138 361.444 88.791 360.769 87.3755 361.358C85.96 361.947 85.2878 363.577 85.8741 364.999C86.4604 366.42 88.0832 367.096 89.4987 366.507Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0078 363.932L81.9327 358.608C81.9327 358.608 81.6072 358.117 81.6072 357.668C81.6072 357.219 82.1771 357.055 82.1771 357.055",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4453 360.099C82.3002 360.712 83.0629 360.958 84.1301 363.347C84.3745 363.899 84.6176 364.492 85.6764 364.574L88.4352 363.932",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7766 354.736C85.7766 355.193 85.5168 355.563 85.1969 355.563C84.877 355.563 84.6172 355.193 84.6172 354.736C84.6172 354.278 84.877 353.908 85.1969 353.908C85.5168 353.908 85.7766 354.278 85.7766 354.736Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8008 354.277C84.8008 354.277 85.2883 354.766 85.7772 354.737",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5938 353.908C85.5938 353.908 85.8983 353.724 86.2656 354.03C86.6316 354.336 86.6316 355.132 87.242 355.132",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3238 356.299C85.3238 356.299 85.2316 357.556 84.4689 357.984C83.9214 358.291 82.9827 358.054 82.5469 357.922",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7782 355.747C86.8468 356.053 87.5704 357.457 87.7925 358.321C88.28 360.221 84.8633 360.345 84.8633 360.345L85.1678 363.165",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4384 362.244C84.4384 362.244 83.3404 360.283 83.8279 359.608C84.3154 358.933 86.2082 358.627 86.2082 358.627",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.352 366.858H308.087",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.152 356.382C302.671 356.382 305.523 352.073 305.523 346.757C305.523 341.441 302.671 337.132 299.152 337.132C295.634 337.132 292.781 341.441 292.781 346.757C292.781 352.073 295.634 356.382 299.152 356.382Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.016 366.592V351.197",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.501 354.425C293.532 355.592 292.268 356.299 290.884 356.299C287.836 356.299 285.363 352.871 285.363 348.644C285.363 344.417 287.834 340.989 290.884 340.989C291.646 340.989 292.371 341.204 293.032 341.591",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.766 360.291V353.176",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.355 379.845C285.803 379.935 285.453 379.845 285.38 378.96L285.363 378.341",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.973 389.617L283.434 394.738",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.439 394.572L288.359 390.048",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.53 378.378L285.363 378.295C285.363 377.989 285.637 377.334 286.502 377.238C287.946 377.079 288.269 379.614 288.269 379.614L286.985 380.088L286.531 378.378H286.53Z",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.71 381.072C286.54 381.278 286.354 381.638 286.223 382.27L285.952 383.826L283.785 385.189",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.569 380.508C287.888 381.572 287.651 382.604 287.651 384.227L288.65 389.536H284.062L285.405 385.023",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.874 381.262C285.874 381.262 285.193 381.977 285.059 382.361C285.059 382.361 285.229 382.823 285.466 383.133",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.206 394.39L274.255 393.486L275.142 392.239L274.494 390.744L273.921 390.276C273.921 390.276 273.034 390.302 272.688 390.187C272.341 390.072 272.385 389.588 272.385 389.588L273.228 389.406L273.455 388.986L274.034 388.772L274.484 389.699",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.953 389.236L275.823 389.955L279.934 390.721C280.694 391.243 280.786 392.528 281.159 393.027",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.723 392.31C277.466 392.31 278.12 391.623 279.03 391.711C279.03 391.711 279.501 393.195 280.663 393.737V394.969",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.109 393.363L276.38 394.912",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18 393.363L278.875 394.572",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.934 390.721C279.934 390.721 280.685 390.721 280.661 389.617",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.496 390.744L275.826 389.954C275.826 389.954 279.937 388.77 283.437 385.48",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.65 384.226H286.566",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.087 394.84C342.689 393.748 341.589 392.961 340.29 392.961C340.143 392.961 339.999 392.974 339.858 392.994C339.555 390.533 337.328 388.622 334.623 388.622C332.438 388.622 330.563 389.87 329.763 391.647C329.025 391.034 328.054 390.66 326.991 390.66C325.997 390.66 325.084 390.986 324.364 391.53C323.504 390.211 321.956 389.329 320.186 389.329C317.484 389.329 315.293 391.385 315.293 393.92C315.293 394.234 315.326 394.541 315.391 394.838H343.087V394.84Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.502 402.094H253.531",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.79297 394.84H131.683L134.119 397.418V402.094",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 402.094H132.059",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.263 394.84H253.573L251.469 397.088V402.094",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.194 327.901C251.812 327.901 254.744 324.956 254.744 321.322C254.744 317.689 251.812 314.743 248.194 314.743C244.577 314.743 241.645 317.689 241.645 321.322C241.645 324.956 244.577 327.901 248.194 327.901Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.087 333.638H247.299L246.746 331.027H249.64L249.087 333.638Z",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.996 326.1L249.641 331.027",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.748 331.027L244.395 326.1",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.664 326.1L247.474 331.027",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.666 326.1L248.855 331.027",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7936 387.216C40.5493 387.975 40.2937 389.462 40.2937 389.462C40.2937 389.462 38.813 389.719 38.0573 388.96C37.3016 388.201 37.5572 386.714 37.5572 386.714C37.5572 386.714 39.0379 386.457 39.7936 387.216Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7644 386.371C46.2589 385.875 47.2269 386.043 47.2269 386.043C47.2269 386.043 47.3945 387.015 46.9 387.512C46.4055 388.009 45.4375 387.84 45.4375 387.84C45.4375 387.84 45.2699 386.868 45.7644 386.371Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6784 387.645C51.1729 387.149 52.141 387.317 52.141 387.317C52.141 387.317 52.3086 388.289 51.8141 388.786C51.3196 389.283 50.3516 389.114 50.3516 389.114C50.3516 389.114 50.184 388.142 50.6784 387.645Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3041 394.936L36.6602 390.888H53.3358L52.6918 394.936",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2948 386.252L40.9219 386.941",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5977 386.941L43.0321 387.29",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1484 387.867L48.5479 387.29",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 388.215H42.3471",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2539 388.896H48.1507",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 388.087L44.1486 390.888",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8711 388.643V390.888",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2578 388.896L49.5484 390.888",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9219 393.389L42.2447 392.434L43.5675 393.389L44.8889 392.434L46.2118 393.389L47.5332 392.434L48.856 393.389",
    stroke: "#D1D2DC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.559 355.913C116.559 355.913 116.849 356.493 116.788 356.94",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.894 356.55L116.558 355.913C116.558 355.913 115.803 354.99 115.258 355.902C114.782 356.7 115.516 357.271 115.516 357.271",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.812 357.865L118.028 356.664L119.433 354.543",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.677 361.946L116.384 363.363L114.832 363.146L115.138 361.757L115.399 360.671C115.399 360.671 115.191 358.844 115.266 358.387C115.342 357.929 115.512 357.663 115.512 357.663",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.784 363.075C117.784 363.075 117.519 361.455 117.33 360.673H115.953",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.549 363.315L115.215 366.64",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.457 366.104L117.291 363.904L117.168 363.253",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.387 360.19L117.487 358.498C117.487 358.498 117.537 357.754 117.387 357.664",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66 357.918L119.084 356.927L119.141 355.601",
    stroke: "#16161E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.913 348.203C126.59 348.259 126.268 348.32 125.947 348.386C124.308 348.721 122.599 349.318 121.506 350.612C121.076 351.121 120.332 352.216 119.707 353.385",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.882 329.549C157.715 331.091 154.5 332.668 151.85 334.978C149.464 337.061 147.69 339.681 145.453 341.898C143.002 344.327 140.02 345.709 136.609 346.446C135.106 346.77 133.583 346.976 132.059 347.167",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.316 330.305L170.394 321.821L166.929 313.698L158.844 317.179L160.316 330.305Z",
    fill: "#20996B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.363 316.979L164.624 319.5L167.18 313.106",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.868 322.012L164.619 319.5L160.316 330.305",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.141 364.175H277.792",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.988 350.47V348.315",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.163 348.315H266.766V345.913H284.163",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.988 345.913V338.72L270.44 337.263V297.844H276.126V293.918H280.705V297.844H286.083",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.986 319.12V297.844H304.301V293.918H291.459V297.844H286.082",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.167 314.714V297.844H314.481V293.918H305.152",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.312 300.654H321.621",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.074 305.726H274.52V308.292H277.074V305.726Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.094 305.726H281.539V308.292H284.094V305.726Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.113 305.726H288.559V308.292H291.113V305.726Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.133 305.726H295.578V308.292H298.133V305.726Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.152 305.726H302.598V308.292H305.152V305.726Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.074 313.839H274.52V316.405H277.074V313.839Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.113 313.839H288.559V316.405H291.113V313.839Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.133 313.839H295.578V316.405H298.133V313.839Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.152 313.839H302.598V316.405H305.152V313.839Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.074 321.951H274.52V324.517H277.074V321.951Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.113 321.951H288.559V324.517H291.113V321.951Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.133 321.951H295.578V324.517H298.133V321.951Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.152 321.951H302.598V324.517H305.152V321.951Z",
    fill: "#D1D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.482 297.844H309.988",
    stroke: "#16161E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76 331.737H282.68V333.042H278.6V331.737H274.52",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.897 331.737H299.817V333.042H295.736V331.737H291.656",
    stroke: "#CECFD8",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3998_38015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.1484 82.7111) rotate(28.5872) scale(854.7 1123.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white",
    stopOpacity: 0.325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "white",
    stopOpacity: 0.135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white",
    stopOpacity: 0.684118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white",
    stopOpacity: 0.638351
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3998_38015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 385,
    height: 114,
    fill: "white",
    transform: "translate(-10 298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomemobileabstract);
export default __webpack_public_path__ + "static/media/homemobileabstract.8f3cb5c345ae6d034a68aa2bc3ab940b.svg";
export { ForwardRef as ReactComponent };